<div class="spinner-wrapper">
    <mat-spinner></mat-spinner>
    <div class="states">
        <div *ngFor="let state of getStates(); let index = index;" [@outIn]="getAnimationState(index)"
             [class]="'state ' + getAnimationState(index)">{{state | translate}}</div>
    </div>
</div>
